<div class="cardx mr-1">
  <div class="card-bodyx center">
    <div class="card-titlex text-center h4 mb-0">{{pageTitle}}</div>
    <div id="content" class="capacity"></div>
  </div>
</div>
